import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest,
  HttpResponse, HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { throwError } from 'rxjs';
import { NotificationService } from '@core/services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {
  private countRequest = 0;

  constructor(
    private loaderService: LoaderService,
    private notificationService: NotificationService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const ignoreLoading = req.params.has('ignoreLoading');

    const clonedReq = req.clone({
      setHeaders: {
        'X-Client-Origin': 'ANGULAR_WEB'
      }
    });

    if (!ignoreLoading) {
      this.showLoader();
      this.countRequest++;
    }

    return next.handle(clonedReq).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && !ignoreLoading) {
          this.countRequest--;
          this.onEnd();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (!ignoreLoading) {
          this.countRequest--;
          this.onEnd();
        }

        let errorMessage = 'Ocorreu um erro inesperado.';
        if (error.status === 409 && error.error) {
          errorMessage = error.error;
        }

        return throwError(() => error);
      })
    );
  }

  private onEnd(): void {
    if (this.countRequest === 0) {
      this.hideLoader();
    }
  }

  private showLoader(): void {
    this.loaderService.show();
  }

  private hideLoader(): void {
    this.loaderService.hide();
  }
}